var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "mapContainer",
    staticStyle: {
      "height": "100%",
      "min-height": "250px",
      "position": "relative"
    }
  }, [_c('CoreMapboxMglMap', {
    ref: "mapGl",
    attrs: {
      "interactive": _vm.interactive
    },
    on: {
      "load": _vm.onMapLoaded,
      "resize": _vm.onMapResized
    }
  }, _vm._l(_vm.unclusteredTwins, function (twin, index) {
    return _c('twin-map-marker', {
      key: `${twin.id}-${index}`,
      style: _vm.getMarkerStyle(twin, index),
      attrs: {
        "twin": twin,
        "widget": _vm.widget,
        "custom-parameters": _vm.customParameters
      },
      on: {
        "click:action": function ($event) {
          return _vm.$emit('click:action', $event);
        }
      }
    });
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };